import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useGetStorefrontQuery } from '../../../../store/endpoints/StorefrontSettingsEndpoints';
import { Pivot, PivotItem } from '@fluentui/react';
import DashboardGrid from '../../../../components/Dashboard/DashboardGrid';
import StorefrontOrdersTable from '../../../../components/Storefront/Orders/StorefrontOrdersTable';
import StorefrontCartsTable from '../../../../components/Storefront/Carts/StorefrontCartsTable';
import PreparedCartsTable from '../../../../components/Storefront/PreparedCart/PreparedCartsTable';
import StorefrontSettingsTitleBar from '../../../../components/Storefront/StorefrontSettingsTitleBar';
import { useUrlTabState } from '../../../../hooks/useUrlState';

interface StorefrontEditorPageParams {
    storefront: string;
}

const StorefrontDashboardPage: React.FC<RouteComponentProps<StorefrontEditorPageParams>> = (props) => {
    const { storefront } = props.match.params;
    const sSettingsQuery = useGetStorefrontQuery(storefront, {skip: !storefront});
    // URL-addressable tab (?tab=orders) so deep links and the global search can land on a
    // specific tab; matches the registry's storefront.dashboard.* areas.
    const [selectedTab, setSelectedTab] = useUrlTabState('dashboard');

    return <div>
        <StorefrontSettingsTitleBar
            storefront={storefront}
            title={`Storefront Management${sSettingsQuery.data?.name ? ` - ${sSettingsQuery.data.name}` : ''}`}
        />
        <Pivot selectedKey={selectedTab} onLinkClick={(item) => setSelectedTab(item?.props.itemKey)}>
            <PivotItem itemKey='dashboard' headerText='Dashboard'>
                <DashboardGrid resource="storefront" resourceId={storefront} />
            </PivotItem>
            <PivotItem itemKey='orders' headerText='Orders'>
                <StorefrontOrdersTable storefront={storefront} />
            </PivotItem>
            <PivotItem itemKey='carts' headerText='Customer Carts'>
                <StorefrontCartsTable storefront={storefront} />
            </PivotItem>
            <PivotItem itemKey='preparedCarts' headerText='Prepared Carts'>
                <PreparedCartsTable storefront={storefront} />
            </PivotItem>
        </Pivot>

    </div>
};

export default StorefrontDashboardPage;